module.exports = __webpack_public_path__ + "img/apple_get_a_copy.304ff192.jpg";